// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"184db99a","977":"a1d917ce"}[chunkId] + ".chunk.js";
};